module.exports = __webpack_public_path__ + "static/media/s_sf_9.d1d1f92c.png";